export default "__VITE_ASSET__0MlITOs___"